import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import '@mdi/font/css/materialdesignicons.css';
import Vue3Autocounter from 'vue3-autocounter';
import axios from './plugins/axios';
import moment from 'moment';
import VCalendar from 'v-calendar';
import 'v-calendar/dist/style.css';
import io from 'socket.io-client';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import 'ant-design-vue/dist/antd.dark.css';
import VueCookies from 'vue3-cookies';
import { createI18n } from 'vue-i18n';
import { ko, en, cn, vn } from './locales';

// if (store.state.isAuthenticated) {
//   socket = io('wss://api.aone-02.com');
//   // socket = io('http://localhost:3000');
// }
// const socket = io('ws://localhost:10990');
// const socket = io('wss://api.kordellcasino.com');
// const socket = io('wss://localhost:10990');

const comma = val => {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const uncomma = val => {
  return String(val).replace(/[^\d]+/g, '');
};

const translateSportName = e => {
  switch (e) {
    case 'soccer':
      return '축구';
    case 'basketball':
      return '농구';
    case 'volleyball':
      return '배구';
    case 'baseball':
      return '야구';
    case 'icehockey':
      return '아이스하키';
    case 'americanfootball':
      return '미식축구';
    case 'tabletennis':
      return '탁구';
    case 'tennis':
      return '테니스';
    case 'esports':
      return '이스포츠';
    case 'boxingufc':
      return '복싱';
  }
};

const translateMarketName = e => {
  switch (e) {
    case '1x2':
      return '승무패';
    case '12':
      return '승패';
    case 'dnb':
      return '승패';
    case 'ou':
      return '언더오버';
    case 'ah':
      return '핸디캡';
    case 'oe':
      return '점수합 홀짝';
    case 'cs':
      return '점수맞추기';
    case '1x2_hc':
      return '승무패 핸디캡';
    case 'dc':
      return '더블찬스';
    case 'bts':
      return '양팀득점여부';
    case 'win':
      return '승리팀';
    case 'ht_ft':
      return '전/후반 승리팀';
    case 'ats':
      return '원정팀 득점';
    case 'hts':
      return '홈팀 득점';
    case 'nog':
      return '양팀 골합';
    case 'dib':
      return '전/후반 동점';
    case 'iss':
      return '득/무득';
    case 's_ou':
      return '세트 언오버';
    case 'r_ou':
      return '라운드 언오버';
    case 'fts':
      return '첫 득점팀';
    case 's_ah':
      return '세트 핸디캡';
    case 'p_ah':
      return '포인트 핸디캡';
    case 'p_ou':
      return '포인트 언오버';
    default:
      return e;
  }
};

const peroidTranslate = e => {
  if (e === 'ord') return '정규시간';
  if (e === 'ot') return '연장';
  if (e === 'fe') return '연장포함 풀타임';
  if (e === '1h') return '전반';
  if (e === '2h') return '후반';

  if (e === 'f3i') return '1~3이닝';
  if (e === 'f5i') return '1~5이닝 (전반)';
  if (e === 'f7i') return '1~7이닝';

  if (e.includes('p')) return `${e.replace('p', '')}피리어드`;
  if (e.includes('q')) return `${e.replace('q', '')}쿼터`;
  if (e.includes('s')) return `${e.replace('s', '')}세트`;
  if (e.includes('r')) return `${e.replace('r', '')}라운드`;
  if (e.includes('i')) return `${e.replace('i', '')}이닝`;
};

const drawOddsTranslate = (odds, line) => {
  if (odds === null && line === null) return 'VS';

  if (odds === null && line !== null) return line;

  return odds;
};

const app = createApp(App);

// 유틸
app.config.globalProperties.$comma = comma;
app.config.globalProperties.$uncomma = uncomma;
app.config.globalProperties.$translateSportName = translateSportName;
app.config.globalProperties.$translateMarketName = translateMarketName;
app.config.globalProperties.$peroidTranslate = peroidTranslate;
app.config.globalProperties.$drawOddsTranslate = drawOddsTranslate;
app.config.globalProperties.$moment = moment;
// app.config.globalProperties.$socket = socket;

app.config.globalProperties.$axios = axios;

app.use(Vue3Autocounter);
app.use(VCalendar, {});
app.use(Antd);
app.use(VueCookies);

const i18n = createI18n({
  locale: 'ko',
  fallbackLocale: 'ko',
  messages: { ko, en, cn, vn },
});

app.use(i18n);

app.use(ElementPlus);

app.use(store).use(router).mount('#app');
